module.exports = __webpack_public_path__ + "static/media/twerp.f1281d4a.mp3";